function Timer(intervalCallback, interval = 1000, errorCallback) {
  this.interval = interval;

  this.start = (duration, completedCallback) => {
    if (duration) {
      this.targetEndTime = Date.now() + duration;
    }
    if (completedCallback) {
      this.completedCallback = completedCallback;
    }
    this.expected = Date.now() + this.interval;
    this.tick();
  };

  this.stop = (stopCallback) => {
    clearTimeout(this.timeout);
    if (stopCallback) stopCallback();
  };

  this.tick = () => {
    if (this.targetEndTime && this.expected >= this.targetEndTime) {
      if (this.completedCallback) this.completedCallback();
      return this.stop();
    }

    const timeDrift = Date.now() - this.expected;
    const nextInterval = this.interval - timeDrift;

    if (timeDrift > this.interval && errorCallback) {
      errorCallback();
    }

    if (intervalCallback) intervalCallback();

    this.expected += this.interval;
    this.timeout = setTimeout(this.tick, nextInterval);
  };
}

module.exports.Timer = Timer;
